import { COOKIE_CONSENT } from "shared/interfaces";

export const useCommonStore = defineStore("common", () => {
	const cookieConsent = ref({
		isSeen: false
	});

	const updateCookieConsent = (consent: COOKIE_CONSENT) => {
		const preferences = {
			ad_user_data: consent,
			ad_personalization: consent,
			ad_storage: consent,
			analytics_storage: consent
		};

		const { gtag } = useGtag();
		gtag("consent", "update", preferences);
	};

	return {
		cookieConsent,

		updateCookieConsent
	};
}, {
	persist: {
		paths: ["cookieConsent"],
		storage: persistedState.cookiesWithOptions({
			sameSite: true,
			maxAge: 2147483647
		})
	}
});
